export const styles = theme => ({
  textField: {
    width: 'calc(100% - 30px)',
    marginLeft: 15,
    marginRight: 15,
  },
  textFieldFullWidth: {
    width: '100%',
  },
});